import * as React from 'react';
import { Editor } from '@tiptap/react';

import { TableRowActions } from '../table-row-actions';
import { TableColumnActions } from '../table-column-actions';

export const TableWrapper: React.FC<{
  editor: Editor;
  children: React.ReactNode;
}> = ({ editor, children }) => {
  const [tables, setTables] = React.useState<HTMLTableElement[]>([]);

  React.useEffect(() => {
    const updateTables = (): void => {
      if (!editor?.view?.dom) return;

      const editorDom = editor.view.dom;
      const tableElements = Array.from(editorDom.querySelectorAll('table'));

      const bodyTables = Array.from(document.querySelectorAll('table'));

      const allTables = tableElements.length > 0 ? tableElements : bodyTables;
      setTables(allTables);
    };

    const initialTimer = setTimeout(updateTables, 100);

    const observer = new MutationObserver(() => {
      updateTables();
    });

    if (editor?.view?.dom) {
      observer.observe(editor.view.dom, {
        childList: true,
        subtree: true,
      });
    }

    const handleUpdate = (): void => {
      setTimeout(updateTables, 50);
    };

    editor.on('update', handleUpdate);
    editor.on('selectionUpdate', handleUpdate);

    return () => {
      clearTimeout(initialTimer);
      observer.disconnect();
      editor.off('update', handleUpdate);
      editor.off('selectionUpdate', handleUpdate);
    };
  }, [editor]);

  return (
    <>
      {children}
      {tables.map((table, index) => (
        <React.Fragment key={`table-${index}-${table.dataset.pos || index}`}>
          <TableRowActions editor={editor} tableElement={table} />
          <TableColumnActions editor={editor} tableElement={table} />
        </React.Fragment>
      ))}
    </>
  );
};
